<div class="loader-main-container" *ngIf="loading">
    <div class="loader-container">
      <div class="loader"></div>
      <span class="loader-text">
        {{ text }}
      </span>
    </div>
  </div>